import { SortLabels } from './SortLabels';
import { SortValues } from './SortValues';

export const SORT_OPTIONS = [
  { label: SortLabels.TRENDING, value: SortValues.TRENDING },
  { label: SortLabels.MOST_RECENT, value: SortValues.MOST_RECENT },
  // { label: SortLabels.CONTENT_TYPE, value: SortValues.CONTENT_TYPE },
];
